// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}`, "",{"version":3,"sources":["webpack://./../../node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],"names":[],"mappings":"AAAA,mBAAmB,UAAU,CAAC,aAAa,CAAC,aAAa,CAAC,cAAc","sourcesContent":[".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
